<template>
  <div class="nx-staff-notification-stack">
    <v-slide-y-transition
      group
      origin="top 0"
    >
      <nx-notification
        v-for="notification in justReceivedNotifications"
        :key="notification.id"
        class="mb-2"
        closable
        :title="notification.title"
        :title-variables="notification.titleVariables"
        :chip="notification.tag"
        :chip-color="notification.tagColor"
        :image="notification.imageSrc"
        :url="notification.url"
        :auto-close="notification.autoClose"
        :datetime="notification.creationDate"
        :show-actions="false"
        @input="handleInput(notification)"
        @autoclose="dismissNotification(notification)"
        @dismiss="dismissAndReadNotification(notification)"
      />
    </v-slide-y-transition>
  </div>
</template>

<script>
import NxNotification from '@/components/notification/Notification.vue';
import ManagesStaffNotifications from '@/modules/staff-notification/mixins/manages-staff-notifications';

export default {
  name: 'NxStaffNotificationJustNotifiedStack',
  components: { NxNotification },
  mixins: [ManagesStaffNotifications],
  methods: {
    async dismissAndReadNotification(notification) {
      const dismissedNotification = await this.dismissNotification(notification);
      await this.readNotification(dismissedNotification);
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-staff-notification-stack {
  position: absolute;
  top: 72px;
  right: 24px;
  display: flex;
  flex-direction: column;
  width: 328px;
  z-index: 6;
}
</style>
